<app-generic-entity-form
  [entityDefinition]="entityDefinition"
  [entity]="entity"
  [parentId]="parentId"
  [mode]="mode"
  [additionalData]="additionalData"
  (formSubmit)="onFormSubmit($event)"
  (formCancel)="onFormCancel()"
  (deleteRequest)="onDeleteRequest($event)" />
